import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import displayError from '../../utilities/displayError';

const NumberField = ({
  input = {},
  meta = {},
  className = null,
  errorMessage = null,
  placeholder = null,
  attributes = {},
  inputClassName = '',
  preInputElements,
  postInputElements,
  showErrorOnChange = false
}) => {
  const { error, submitFailed, touched } = meta;
  const showError = !!((error && submitFailed) || (error && showErrorOnChange && touched));
  const inputGroup = classNames({ 'input-group': preInputElements || postInputElements });

  document.addEventListener('wheel', function(event) {
    if ('number' === document.activeElement.type && document.activeElement.classList.contains('noscroll')) {
      document.activeElement.blur();
    }
  });

  return (
    <div className={classNames('number-input', className)}>
      <div className={inputGroup}>
        { preInputElements }
        <input
          {...input}
          className={classNames('form-control noscroll', inputClassName, { error: showError })}
          type="number"
          placeholder={placeholder}
          returnKeyType="done"
          pattern="[0-9]*"
          {...attributes}
        />
        { postInputElements }
      </div>
      { showError &&
        <p className="error text-danger text-small">
          {displayError(errorMessage, error) }
        </p>
      }
    </div>
  );
};

NumberField.propTypes = {
  input: PropTypes.object,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  attributes: PropTypes.object,
  inputClassName: PropTypes.string,
  preInputElements: PropTypes.element,
  postInputElements: PropTypes.element,
  showErrorOnChange: PropTypes.bool
};

export default NumberField;
